import AdminInput from "../../components/AdminInput";
import { useTranslation } from "react-i18next";

const EmailRecipients = ({
    loading,
    data
}) => {
    const { t } = useTranslation();
    return (
        <div className="card-body px-4">
            <h5 className="account-section-title pt-2">Additional Email Recipients</h5>
            {/* <p className="account-text-label mb-0 fs-12">
                {t("myPage.accountInformation.subMenu.emailRecipients.desc")}
            </p> */}
            <hr className="hr-grey-account" />
            <div className="row d-flex align-items-start justify-content-between">
                <div className="col-12 col-lg-auto mb-3 mb-lg-0">
                    {
                        data?.businessDetail?.emailRecipients.length > 0 ? (
                            data?.businessDetail?.emailRecipients?.map((v, i) => (
                                <div className="email-item" key={i}>
                                    <p className='account-text-value mb-0 pe-3'>{v}</p>
                                </div>
                            ))
                        ) : (
                            "-"
                        )
                    }
                </div>
                {
                    false && (
                        <div className="col-12 col-lg-2 d-flex align-items-start justify-content-end">
                            <button
                                type="button"
                                className="btn btn-edit-account px-2 py-2 mt-2 mt-lg-0 pointer"
                                onClick={() => { }}
                            >
                                {t("myPage.accountInformation.subMenu.emailRecipients.button")}
                            </button>
                        </div>
                    )
                }
            </div>
        </div>
    );
};

export default EmailRecipients;
